import React, { useState, useEffect, useRef } from 'react';
import './App.css';


  const Splash = (props) => {
    const style = {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column", // Added this to stack elements vertically
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        position: "fixed",
        zIndex: 1000,
        fontSize: 50,
    };
  
    return (
        <div className="splash-screen" style={style}>
            <div>Cofounder AI</div>
            <img style={{ width: 30 }} src="./loading2.gif" />
        </div>
    );
};


  
  export default Splash;